import { Box, Stack } from '@mui/material';
import React from 'react';
import { use100vh } from 'react-div-100vh';

import {
  AppSidebar,
  BrandNameWithLogo,
  BusinessSwitcher,
  SidebarProvider,
} from '@/components/common';
import { useDashboardNavItems, useDevice } from '@/hooks';

import { Header } from './Header';

interface DashboardLayoutProps {
  children: React.ReactNode;
}
export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
}) => {
  const height = use100vh();
  const navItems = useDashboardNavItems();
  const { isMobile } = useDevice();

  return (
    <SidebarProvider
      initialState={'expanded'}
      variant={isMobile ? 'overlay' : 'collapsible'}
      isCollapsible={true}
    >
      <Box sx={{ display: 'flex', height }}>
        <AppSidebar
          navItems={navItems}
          childrenVariant="tree"
          header={(isCollapsed) => {
            return (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent={isCollapsed ? 'center' : 'space-between'}
                sx={{
                  p: 2,
                  minHeight: 64,
                }}
              >
                <BrandNameWithLogo showLogoOnly={isCollapsed} />
              </Stack>
            );
          }}
          footer={(isCollapsed) => {
            return (
              <Box sx={{ p: 1, borderRadius: 1, overflow: 'hidden' }}>
                <BusinessSwitcher isCollapsed={isCollapsed} />
              </Box>
            );
          }}
        />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            mt: 0,
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'scroll',
          }}
        >
          <>
            <Header />
            <Box px={{ xs: 2, md: 3 }} flexGrow={1}>
              {children}
            </Box>
          </>
        </Box>
      </Box>
    </SidebarProvider>
  );
};
